export class AppConfig {
  //public readonly apiUrl = 'https://api.omnieticaret.com/api/';
  public readonly apiUrl = 'https://api.hesap.co/api/';
};